import * as Effect from "effect/Effect";
export const makeStore = (initialState) => Effect.sync(() => {
    const listeners = new Set();
    let currentState = initialState;
    const store = {
        subscribe(listener) {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        },
        getState() {
            return currentState;
        },
        setState: (state) => Effect.sync(() => {
            if (state === currentState)
                return;
            currentState = state;
            listeners.forEach((listener) => listener());
        }),
    };
    return store;
});
